export default {"src":"/_next/static/media/canva.0344c508.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};